import { render, staticRenderFns } from "./content-sections.datagrid.vue?vue&type=template&id=6c973861&scoped=true&"
import script from "./content-sections.datagrid.vue?vue&type=script&lang=js&"
export * from "./content-sections.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./content-sections.datagrid.vue?vue&type=style&index=0&id=6c973861&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c973861",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
